import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=575c6536&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style1 from "./layout.vue?vue&type=style&index=1&id=575c6536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c6536",
  null
  
)

export default component.exports